import React, { useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown } from "@fortawesome/free-solid-svg-icons";

function ActionDropdown({ actions = [], ariaLabel = "Actions" }) {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(prev => !prev);

  return (
    <Dropdown isOpen={open} toggle={toggle}>
      <DropdownToggle
        color="transparent"
        className="d-flex align-items-center border-0"
        aria-label={ariaLabel}
        style={{ fontSize: "1.2rem" }}
      >
        <FontAwesomeIcon
          icon={faChevronDown}
          style={{
            transition: "transform 0.3s ease",
            transform: open ? "rotate(180deg)" : "rotate(0deg)"
          }}
        />
      </DropdownToggle>

      <DropdownMenu end>
        {actions.map((action, idx) => (
          <DropdownItem key={idx} onClick={action.onClick}>
            {action.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
}

export default ActionDropdown;
